<template>
  <li class="material">
    <div class="swatch" :style="{ backgroundImage: `url(${image})` }"></div>
    <h4>{{ name }}</h4>
    <p v-if="description" class="small">{{ description }}</p>
  </li>
</template>

<script>
export default {
  name: "Material",
  props: {
    image: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: "Name"
    },
    description: String
  }
};
</script>

<style lang="scss" scoped>
@import "./../theme/index.scss";

.material {
  padding: 0;
  margin: 0;
  margin-right: 32px;

  &:last-child {
    margin-right: 0;
  }

  .swatch {
    display: block;
    box-sizing: border-box;
    width: 192px;
    height: 192px;
    background: rgba(0, 0, 0, 0.1);
    background-size: cover;
    border: 1px solid #2d2d2d;
    box-shadow: inset 0 0 0 4px #f4f4f4;
    display: block;
  }

  h4 {
    margin-top: 16px;
    font-size: 12px;
    max-width: 192px;
  }

  p {
    padding: 0;
    margin: 0;
  }
}
</style>
